module.exports = __webpack_public_path__ + "static/img/sau.e9be476b.png";